import { CardData } from "./GridLayout";

export interface ShadowProps {
  shadowType: string;
  shadowColor: string;
}

export function getShadowProps(
  card: CardData,
  shadowMode: "none" | "black" | "status" | "template" | "folder"
): ShadowProps {
  if (shadowMode === "none") {
    return { shadowType: "none", shadowColor: "transparent" };
  }
  
  if (shadowMode === "black") {
    return { shadowType: "black", shadowColor: "#000000" };
  }
  
  if (shadowMode === "status") {
    return {
      shadowType: "status",
      shadowColor: card.statusColor || card.shadowColor || "#000000"
    };
  }
  
  if (shadowMode === "template") {
    return {
      shadowType: "template",
      shadowColor: card.iconBg || card.shadowColor || "#000000"
    };
  }
  
  if (shadowMode === "folder") {
    // Use folder color from card (subfolderColor or folderColor)
    const folderColor = (card as any).subfolderColor || (card as any).folderColor;
    return {
      shadowType: "folder",
      shadowColor: folderColor || card.shadowColor || "#000000"
    };
  }
  
  // Fallback
  return {
    shadowType: card.shadowType || "black",
    shadowColor: card.shadowColor || "#000000"
  };
}

